import { render, staticRenderFns } from "./written-test-detail.vue?vue&type=template&id=ce166adc&scoped=true&"
import script from "./written-test-detail.vue?vue&type=script&lang=js&"
export * from "./written-test-detail.vue?vue&type=script&lang=js&"
import style0 from "./written-test-detail.vue?vue&type=style&index=0&id=ce166adc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce166adc",
  null
  
)

export default component.exports